<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title class="modal-title">{{ 'Nav.Checkout' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-item lines="none">
      <ion-label>
        <h2>{{ 'Checkout.PersonnalInformation' | translate }}</h2>
      </ion-label>
      <ion-note slot="end"><span style="color:red;">*</span> {{ 'General.RequiredFields' | translate }}
    </ion-note>
  </ion-item>
  <store-checkout-personal-info-form [submitted]="submitted" (onSubmit)="onPersonalInfoFormChanged($event)"></store-checkout-personal-info-form>

  <ion-item lines="none">
    <ion-label>
      <h2 class="hidden-sm-up">{{ 'Checkout.PaymentInformation' | translate }}</h2>
      <h2 class="hidden-xs-up">{{ 'Checkout.PaymentInformationslicedup1' | translate }}</h2>
      <h2 class="hidden-xs-up">{{ 'Checkout.PaymentInformationslicedup2' | translate }}</h2>
    </ion-label>
    <ion-note slot="end"><span style="color:red;"></span> <img class="hidden-sm-up" style="height:75px;" [src]="secureUrl"><img class="hidden-xs-up" style="height:50px;" [src]="secureUrl"></ion-note>
  </ion-item>
  <ion-item lines="none" class="important-message">
    <ion-icon name="alert-circle-outline" style="font-size:34pt; color:orange;"></ion-icon>
    <ion-label class="ion-text-wrap">
      <h2>{{ 'General.Important' | translate | uppercase }}</h2>
      <p> {{ 'Checkout.ImportantMessage' | translate }} {{ 'Checkout.MerchandRights' | translate }}</p>

    </ion-label>
  </ion-item>

  <ion-grid style="width:100%">
    <ion-row>
      <ion-col size="12">
        <h3 style="font-size: 16px; font-weight: bold;">{{'Checkout.Tip' | translate}}</h3>
      </ion-col>
    </ion-row>
  </ion-grid>
  <store-checkout-tip-form [subTotal]="subTotal" [store]="store" [orderType]="null" (onSubmit)="onTipChanged($event)"></store-checkout-tip-form>

  <reservation-checkout-total [reservationSectionPackages]="reservationSectionPackages"(onTotal)="onTotalChanged($event)" [options]="totalOptions"></reservation-checkout-total>

  @if (!settingService.configuration.hideGiftProgram) {
    <store-checkout-gift-card-form [freeDelivery]="false" [subtotal]="subTotal" [deliveryPrice]="0" [total]="total" [storeId]="store.id" (onSubmit)="onGiftCardChange($event)"></store-checkout-gift-card-form>
  }

  @if (!settingService.configuration.hideECouponProgram) {
    <app-checkout-coupon-form (closeModal)="searchCoupon($event)" (onSubmit)="getDiscountAmount($event)" [order]="null" [total]="total" [subtotal]="subTotal" [storeId]="store.id"></app-checkout-coupon-form>
  }

  @if (!auth.isAuthenticated && !isGiftCardFullyCover) {
    <shared-credit-card-form [submitted]="submitted" (onSubmit)="onGuestCreditCardChanged($event)"></shared-credit-card-form>
    <shared-address [isReservation]="true" [skipProvinceValidation]="false" [submitted]="submitted" (onChange)="onBillingAddressChanged($event)" placeHolder="{{ 'CreditCard.BillingAddress' | translate }}"></shared-address>
  }

  @if (auth.isAuthenticated && !isGiftCardFullyCover) {
    <account-credit-card-checkout (onCardSelected)="onMemberCreditCardChanged($event)" [submitted]="submitted" [storeId]="store.id"></account-credit-card-checkout>
  }
  <ion-item class="order-type-row">
    <ion-label class="ion-text-wrap">
      <p class="bigger-ion-text">
        Prepay Reservation : {{ store.displayName}} -
        <span class="inline-block">{{ store.address.streetNumber }}  {{ store.address.street }}, {{ store.address.city }}, {{ store.address.postalCode }}</span>
      </p>
    </ion-label>
  </ion-item>

  <store-checkout-terms-agreement-form (onSubmit)="onTermsAgreementChanged($event)"></store-checkout-terms-agreement-form>
  <ion-button expand="block" [disabled]="clickedSubmitted || (!termsAgreement || (termsAgreement && !termsAgreement.agreement))"  (click)="pay()">{{ 'General.Pay' | translate }}</ion-button>
</ion-card>
</ion-content>